import React from 'react';
import useApiMutation from '../useApiMutation';
import useMessage from '../../useMessage';
import { FormattedMessage } from 'react-intl';

const useGetPortal = () => {
  const { message } = useMessage();

  const mutation = useApiMutation({
    getRequestUrl: () => '/customer/portal',
    method: 'POST',
    onSuccess: (data) => {
      if (data?.url) {
        window.location = data.url;
      } else {
        message.danger({ content: <FormattedMessage defaultMessage="Stripe URL not found" /> });
      }
    },
    onError: (error) => {
      const errMsg =
        typeof error?.response?.data?.message === 'string' ? (
          error.response.data.message
        ) : (
          <FormattedMessage defaultMessage="Something went wrong" />
        );

      message.danger({ content: errMsg });
      return;
    },
  });

  return {
    getPortalUrl: mutation.mutate,
    isPortalUrlLoading: mutation.isLoading,
    isPortalUrlError: mutation.isError,
    isPortalUrlSuccess: mutation.isSuccess,
    ...mutation,
  };
};

export default useGetPortal;
